export default {
  // fontFamily: ['Droid Sans', 'san-serif'].join(','),
  button: {
    textTransform: 'none',
  },
  subtitle1: {
    fontSize: 16,
    lineHeight: '21px',
    fontWeight: 500,
    // '@media (max-width:600px) and (min-width:330px)': {
    //   fontSize: 18,
    //   lineHeight: '28px',
    // },
  },
  subtitle2: {
    fontSize: 14,
    fontWeight: 500,
    // '@media (max-width:600px) and (min-width:330px)': {
    //   fontSize: 16,
    // },
  },
  subtitle3: {
    fontSize: 12,
    fontWeight: 500,
    // '@media (max-width:600px) and (min-width:330px)': {
    //   fontSize: 14,
    // },
  },
  body1: {
    fontSize: 16,
    fontWeight: 400,
    // '@media (max-width:600px) and (min-width:330px)': {
    //   fontSize: 18,
    // },
  },
  body2: {
    fontSize: 14,
    fontWeight: 400,
    // '@media (max-width:600px) and (min-width:330px)': {
    //   fontSize: 16,
    // },
  },
  body3: {
    fontSize: 12,
    fontWeight: 400,
    '@media (max-width:600px) and (min-width:330px)': {
      fontSize: 12,
    },
  },
  caption: {
    fontSize: 10,
    fontWeight: 400,
    lineHeight: '14px',
  },

  pageMainHeading: {
    fontSize: '30px',
    fontWeight: 'bold',
    color: '#2b2b2b',
    marginBottom: '5px',
  },

  formMainHeading: {
    fontSize: '18px',
    fontWeight: 600,
    lineHeight: 1.22,
    color: '#2b2b2b',
    marginBottom: '20px',
  },

  formInputLabel: {
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: 1.57,
    color: '#2b2b2b',
    marginBottom: '7px',
  },

  formSubText: {
    fontSize: '12px',
    lineHeight: 1.83,
    color: '#2b2b2b',
  },
  sectionMainHeading: {
    fontSize: '42px',
    fontWeight: 600,
    lineHeight: 1,
    color: '#000',
  },
};
